import * as React from "react";
import { tr } from "@linkfluence/i18n";
import { redirectToLogout } from "@linkfluence/visa/auth";
import Modal from "@ui-kit/modal";
import { useCurrentUserLocale } from "../user/use-cases";

interface IProps {
  onClose: () => void;
}

const ProfileLogout = ({ onClose }: IProps) => {
  const locale = useCurrentUserLocale();
  return (
    <Modal
      title={tr(locale, "LOGOUT::MODAL::TITLE")}
      onCancel={onClose}
      onValidate={() => {
        onClose();
        redirectToLogout();
      }}
      locale={locale}
    >
      {tr(locale, "LOGOUT::MODAL::TEXT")}
    </Modal>
  );
};

export default ProfileLogout;
